import { GroupsSearchBarStyles } from "./GroupsBlock.styles";
import ServerSideSearchBar from "../../../components/common/table/ServerSideSearchBar";
import SearchBarButtonContainer from "../../../components/common/table/SearchBarButtonContainer";
import { usePermissionChecker } from "../../../hooks/usePermissionChecker";
import { PermissionEntityType } from "../../../types/permissionType";

interface GroupsSearchBarProps {
  handleOnSearch: (searchQuery: string) => void;
  handleOnCreateGroup: () => void;
}

export default function GroupsSearchBar(props: GroupsSearchBarProps) {
  const { userHasPermission } = usePermissionChecker();
  const canCreateGroup = userHasPermission(PermissionEntityType.Groups, "Create");

  return (
    <GroupsSearchBarStyles>
      <ServerSideSearchBar onSearchHandler={props.handleOnSearch} />
      <SearchBarButtonContainer
        onCreateClick={canCreateGroup ? props.handleOnCreateGroup : undefined}
      />
    </GroupsSearchBarStyles>
  );
};
